import React__default from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

var FormatElementId = function (_a) {
    var elementIdRules = _a.elementIdRules, element = _a.element;
    var t = useTranslation().t;
    // Don't show if the rules don't ask for it
    if (!(elementIdRules === null || elementIdRules === void 0 ? void 0 : elementIdRules.identifier) || !element) {
        return null;
    }
    // Create identifier and extension
    var identifier;
    var extension;
    switch (elementIdRules.identifier) {
        // Be permissive for the name
        case "id":
        case "ID":
        case "iD":
        case "Id":
            identifier = element.id;
            extension = t("format-element-id.identifier-extension.id.label");
            break;
        default:
            console.debug("FormatElementId: identifier not yet supported");
            break;
    }
    // Don't show if we have no formatter yet
    if (identifier === undefined) {
        return null;
    }
    // Print result
    return (React__default.createElement(Typography, { variant: "overline", component: "span", title: "".concat(extension) },
        React__default.createElement("strong", null, identifier),
        elementIdRules.extension && React__default.createElement("small", null, " ".concat(extension))));
};

export { FormatElementId as default };
//# sourceMappingURL=index.js.map
